import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Navigation from "@/components/shared/Navigation";
import Footer from "@/components/shared/Footer";
import { ARCHIVE_VERSIONS } from "./privacyArchives";

const PrivacyPolicyArchive = () => {
  const [activeTab, setActiveTab] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, []);

  const scrollToSection = (sectionId) => {
    navigate(`/?section=${sectionId}`);
  };

  return (
    <div>
      <Navigation
        onSectionClick={scrollToSection}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
      />

      {/* Hero — matches the new privacy policy hero style */}
      <section
        style={{ background: "#0D3D2E", borderBottom: "3px solid #2ECC7A", paddingTop: "calc(48px + 65px)" }}
        className="px-8 pb-12"
      >
        <div className="max-w-4xl mx-auto">
          <p
            className="text-xs font-bold tracking-widest uppercase mb-3"
            style={{ color: "#2ECC7A", fontFamily: "system-ui, sans-serif" }}
          >
            Legal &amp; Privacy
          </p>
          <h1
            className="text-white text-4xl font-normal"
            style={{ fontFamily: "Georgia, 'Times New Roman', serif", lineHeight: 1.2 }}
          >
            Privacy Policy Archive
          </h1>
          <p
            className="mt-4 text-sm max-w-lg"
            style={{ color: "rgba(255,255,255,0.55)", fontFamily: "system-ui, sans-serif" }}
          >
            Archived versions of the HealthismPlus Privacy Policy. All users are governed by
            the{" "}
            <Link
              to="/privacy-policy"
              style={{ color: "#2ECC7A" }}
              className="hover:underline"
            >
              latest version
            </Link>
            .
          </p>
        </div>
      </section>

      {/* Archive list */}
      <div className="max-w-4xl mx-auto px-8 py-16">

        {ARCHIVE_VERSIONS.length === 0 ? (
          <p className="text-[#6B7C70] text-sm">No archived versions yet.</p>
        ) : (
          <div className="space-y-5">
            {ARCHIVE_VERSIONS.map((version) => (
              <div
                key={version.slug}
                className="border rounded-xl p-6 bg-white transition-colors hover:border-[#2ECC7A]"
                style={{ borderColor: "#C8DECE" }}
              >
                <div className="flex items-start justify-between gap-6 flex-wrap">
                  <div className="flex-1 min-w-0">
                    {/* Badges */}
                    <div className="flex items-center gap-2 mb-2 flex-wrap">
                      <span
                        className="text-xs font-bold tracking-widest uppercase"
                        style={{ color: "#2ECC7A", fontFamily: "system-ui, sans-serif" }}
                      >
                        {version.label}
                      </span>
                      <span
                        className="text-xs font-semibold px-2 py-0.5 rounded"
                        style={{
                          background: "#E8F5EE",
                          color: "#1A6645",
                          fontFamily: "system-ui, sans-serif",
                        }}
                      >
                        Superseded
                      </span>
                    </div>

                    {/* Title */}
                    <h2
                      className="text-lg font-semibold mb-1"
                      style={{
                        color: "#0D3D2E",
                        fontFamily: "Georgia, 'Times New Roman', serif",
                        fontWeight: "normal",
                        fontSize: "20px",
                      }}
                    >
                      {version.label} Privacy Policy
                    </h2>

                    {/* Description */}
                    <p
                      className="text-sm mb-4"
                      style={{ color: "#3D5044", fontFamily: "system-ui, sans-serif" }}
                    >
                      {version.description}
                    </p>

                    {/* Meta */}
                    <div
                      className="flex gap-6 flex-wrap text-xs"
                      style={{ color: "#6B7C70", fontFamily: "system-ui, sans-serif" }}
                    >
                      {version.effectiveFrom && (
                        <span>
                          Effective from:{" "}
                          <strong style={{ color: "#3D5044" }}>{version.effectiveFrom}</strong>
                        </span>
                      )}
                      <span>
                        Superseded on:{" "}
                        <strong style={{ color: "#3D5044" }}>{version.effectiveTo}</strong>
                      </span>
                    </div>
                  </div>

                  {/* CTA */}
                  <Link
                    to={`/privacy-policy/archive/${version.slug}`}
                    className="flex-shrink-0 px-4 py-2 rounded-lg text-sm font-medium transition-colors"
                    style={{
                      border: "1px solid #C8DECE",
                      color: "#1A6645",
                      fontFamily: "system-ui, sans-serif",
                      textDecoration: "none",
                    }}
                    onMouseEnter={(e) => (e.currentTarget.style.background = "#E8F5EE")}
                    onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
                  >
                    View version →
                  </Link>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* Footer note */}
        <div
          className="mt-12 pt-8"
          style={{ borderTop: "1px solid #C8DECE" }}
        >
          <p
            className="text-sm"
            style={{ color: "#6B7C70", fontFamily: "system-ui, sans-serif" }}
          >
            Looking for the current policy?{" "}
            <Link
              to="/privacy-policy"
              className="font-medium hover:underline"
              style={{ color: "#1A6645" }}
            >
              View the current Privacy Policy →
            </Link>
          </p>
        </div>
      </div>

      <Footer onSectionClick={scrollToSection} setActiveTab={setActiveTab} />
    </div>
  );
};

export default PrivacyPolicyArchive;
